import { render, staticRenderFns } from "./epg-full.vue?vue&type=template&id=a9473f0a"
import script from "./epg-full.vue?vue&type=script&lang=js"
export * from "./epg-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports